import script from "./ContactGroupChip.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactGroupChip.vue?vue&type=script&setup=true&lang=js"

import "./ContactGroupChip.vue?vue&type=style&index=0&id=f41270d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f41270d6"]])

export default __exports__